module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_resort@3x-6d2c0c825cd82f5bc9c712327d430c9e.webp";